import { UsersClient, baseUrl } from '../../api';
import { BaseActionReducer } from '../baseActionReducer';
export const userIdActionReducer = new BaseActionReducer({ keyStart: 'USER_BY_ID', payloadName: 'user' });
const syncUserIdActions = userIdActionReducer.buildSyncActions();
const usersClient = new UsersClient(null, baseUrl);
const asyncUserIdActionCreators = {
    getUserById: (userId) => {
        return userIdActionReducer.createAsyncAction(usersClient.getUserById(userId));
    }
};
export const loggedInUserActionReducer = new BaseActionReducer({ keyStart: 'LOGGED_IN_USER', payloadName: 'user' });
const syncLoggedInUserActions = loggedInUserActionReducer.buildSyncActions();
const asyncLoggedInUserActionCreators = {
    getUserRoles: (userId, password) => {
        return loggedInUserActionReducer.createAsyncAction(usersClient.getUserRoles(userId));
    }
};
export const userActions = Object.assign(Object.assign(Object.assign(Object.assign({}, syncUserIdActions), asyncUserIdActionCreators), syncLoggedInUserActions), asyncLoggedInUserActionCreators);
